import DataTypeDto from "../datastructuremodule/DataTypeDto";

abstract class TransformationCapabilitiesDto {
    LogicId: number;
    Label: string;
    Icon: number;
    SourceDataType: DataTypeDto;
    TargetDataType: DataTypeDto;
    TransformationCapabilitiesType: string;

    constructor(
        logicId: number,
        label: string,
        icon: number,
        sourceDataType: DataTypeDto,
        targetDataType: DataTypeDto,

        transformationCapabilitiesType: string
    ) {
        this.LogicId = logicId;
        this.Label = label;
        this.Icon = icon;
        this.SourceDataType = sourceDataType;
        this.TargetDataType = targetDataType;
        this.TransformationCapabilitiesType = transformationCapabilitiesType;
    }

    public GetDescription(): string {
        if (this.LogicId === 0) {
            return this.Label;
        }

        return this.Label + " → " + this.TargetDataType.Label;
    }
}

export default TransformationCapabilitiesDto;
